import React from 'react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
    return (
        <div className="min-h-screen bg-gray-50 py-12 px-4">
            <div className="max-w-4xl mx-auto bg-white rounded-lg shadow p-8">
                <h1 className="text-3xl font-bold mb-8">Terms of Service</h1>
                <p className="text-gray-600 mb-6">Effective Date: {new Date().toLocaleDateString()}</p>
                
                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">1. Acceptance of Terms</h2>
                    <p className="text-gray-700 mb-4">
                        By accessing and using the Dentulu Developer Ecosystem ("Service"), you agree to be bound by these Terms of Service ("Terms"). 
                        If you do not agree to these Terms, please do not use our Service.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">2. Developer Account</h2>
                    <p className="text-gray-700 mb-4">
                        To access certain features of the Service, you must register for a developer account. You agree to:
                    </p>
                    <ul className="list-disc ml-8 text-gray-700 mb-4">
                        <li>Provide accurate and complete information</li>
                        <li>Maintain the security of your account credentials</li>
                        <li>Accept responsibility for all activities under your account</li>
                        <li>Notify us immediately of any unauthorized access</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">3. App Submission Guidelines</h2>
                    <p className="text-gray-700 mb-4">When submitting apps to the marketplace, you must:</p>
                    <ul className="list-disc ml-8 text-gray-700 mb-4">
                        <li>Ensure your app complies with HIPAA regulations</li>
                        <li>Not submit apps containing malicious code or malware</li>
                        <li>Provide accurate descriptions and pricing information</li>
                        <li>Respect intellectual property rights</li>
                        <li>Maintain app functionality and provide support</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">4. API Usage</h2>
                    <p className="text-gray-700 mb-4">
                        Access to Dentulu APIs is subject to rate limits and usage guidelines. You agree not to:
                    </p>
                    <ul className="list-disc ml-8 text-gray-700 mb-4">
                        <li>Exceed API rate limits</li>
                        <li>Use APIs for unauthorized purposes</li>
                        <li>Reverse engineer or compromise API security</li>
                        <li>Share API keys or credentials</li>
                    </ul>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">5. Payment and Fees</h2>
                    <p className="text-gray-700 mb-4">
                        For paid apps, Dentulu charges a platform fee of 20% on all transactions. 
                        Payments are processed through Stripe and subject to their terms of service.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">6. Privacy and Data Protection</h2>
                    <p className="text-gray-700 mb-4">
                        You must comply with all applicable privacy laws, including HIPAA. 
                        See our <Link to="/privacy-policy" className="text-blue-600 hover:underline">Privacy Policy</Link> for details.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">7. Termination</h2>
                    <p className="text-gray-700 mb-4">
                        We reserve the right to suspend or terminate your account for violations of these Terms 
                        or for any other reason at our sole discretion.
                    </p>
                </section>

                <section className="mb-8">
                    <h2 className="text-2xl font-semibold mb-4">8. Contact Information</h2>
                    <p className="text-gray-700 mb-4">
                        For questions about these Terms, please contact us at:
                        <br />
                        Email: legal@dentulu.com
                        <br />
                        Address: Dentulu Inc., [Your Address]
                    </p>
                </section>

                <div className="mt-12 pt-8 border-t">
                    <Link to="/" className="text-blue-600 hover:underline">← Back to Home</Link>
                </div>
            </div>
        </div>
    );
}